import React, { Component } from 'react';
import withTranslations from '../../translations';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  getReportTemplates,
  generateReport,
} from '../../actions/reports';

import {
  AlertDialog,
  FormControl,
  FormControlLabel,
  InputLabel,
  Loader,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '../base';

const styles = theme => ({
  reportFormatContainer: {
    marginBottom: theme.spacing(3),
  },
  reportFormatOptionsContainer: {
    flexDirection: 'row',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loader: {
    marginBottom: theme.spacing(),
  },
})

class ReportsDialog extends Component {
  state = {
    reportFormat: 'pdf',
    reportTemplate: undefined,
    isLoading: false,
  };

  componentDidMount() {
    this.props.actions.getReportTemplates(this.props.jobId);
  }

  handleReportFormat = e => this.setState({ reportFormat: e.target.value });

  handleReportTemplate = e => this.setState({ reportTemplate: e.target.value })

  generateReport = async () => {
    const { reportFormat, reportTemplate } = this.state;
    const { reportTemplates, actions, jobId,  } = this.props;
    const reportTemplatePosition = reportTemplates.findIndex(temp => temp.value.templateDescription === reportTemplate);
    this.setState({ isLoading: true });

    await actions.generateReport(jobId, reportTemplates[reportTemplatePosition].value.templateFile, reportTemplate, reportFormat);

    this.setState(() =>
      ({ isLoading: false }),
      () => this.props.handleCancel()
    );
  }

  renderChooseReportFormat = (c, t) =>
    <div className={c.reportFormatContainer}>
      <Typography variant='subtitle1'>{t.reportFormat}</Typography>
      <RadioGroup
        aria-label="Choose report format"
        name="report format"
        className={c.reportFormatOptionsContainer}
        value={this.state.reportFormat}
        onChange={this.handleReportFormat}
      >
        <FormControlLabel value="pdf" control={<Radio />} label="pdf" />
        <FormControlLabel value="docx" control={<Radio />} label="docx" />
      </RadioGroup>
    </div>

  renderSelectReportTemplate = (c, t) =>
    <FormControl fullWidth>
      <InputLabel><Typography color='textSecondary'>{t.reportTemplate}</Typography></InputLabel>
      <Select
        fullWidth
        hasNullOption={false}
        disabled={this.props.reportTemplates && !this.props.reportTemplates.length}
        options={this.props.reportTemplates.map(template =>  template.value.templateDescription)}
        onChange={this.handleReportTemplate}
        value={this.state.reportTemplate}
      />
    </FormControl>

  render() {
    const { classes: c, t, gt, open, handleCancel } = this.props;

    return (
      <AlertDialog
        open={open}
        title={t.title}
        cancelButtonText={gt.cancel}
        confirmButtonText={t.confirmButton}
        handleCancel={handleCancel}
        handleConfirm={this.generateReport}
        confirmDisabled={!this.state.reportTemplate}
      >
        { this.renderChooseReportFormat(c, t) }
        { this.renderSelectReportTemplate(c, t)}
        { this.state.isLoading &&
          <div className={c.loadingOverlay}>
            <Loader className={c.loader} color='secondary' />
            <Typography variant='caption'>Generating report</Typography>
          </div>
        }
      </AlertDialog>
    )
  }
}

const mapStateToProps = state => ({
  reportTemplates: state.reports.reportTemplates,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getReportTemplates: bindActionCreators(getReportTemplates, dispatch),
    generateReport: bindActionCreators(generateReport, dispatch),
  }
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(ReportsDialog, 'ReportsDialog')));



// WEBPACK FOOTER //
// ./src/components/ReportsDialog/ReportsDialog.js